var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "notification-modal" }, [
    _c("header", [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("notification.notifications"))),
        ]),
        _vm._v(" "),
        _vm.unreadNotificationCount > 0
          ? _c("span", { staticClass: "badge" }, [
              _vm._v(_vm._s(_vm.unreadNotificationCount)),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right" },
        [
          _c(
            "SupsisButton",
            {
              attrs: { small: "", ghost: "" },
              on: { click: _vm.toggleInclude },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.filter.includeAll
                      ? _vm.$t("notification.showOnlyUnread")
                      : _vm.$t("notification.showAll")
                  ) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              attrs: { small: "", ghost: "" },
              on: { click: _vm.markAsSeenAll },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("done")]),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("mail.markAsAllRead")) +
                  "\n            "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "content" },
      [
        _c("NotificationListView", {
          attrs: {
            notifications: _vm.data.items,
            toggleReadState: _vm.toggleReadState,
            groupByDate: false,
            minimized: true,
            onCardClick: _vm.onCardClick,
          },
          on: { "load-more": _vm.loadMore },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "footer",
      [
        _c(
          "SupsisButton",
          { attrs: { small: "", ghost: "" }, on: { click: _vm.viewAll } },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("query_stats")]),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("notification.showAll")) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "SupsisButton",
          { attrs: { small: "", ghost: "" }, on: { click: _vm.gotoSettings } },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("settings")]),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("notification.adjustSettings")) +
                "\n        "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }